import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Geracao from "./Geracao";
import Lista from "./Lista";

const Index = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/geracao`} component={Geracao} />
    </Switch>
  </div>
);

export default Index;
